import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'eo-action-menu-button',
  templateUrl: './eo-action-menu-button.component.html',
  styleUrl: './eo-action-menu-button.component.scss',
})
export class EoActionMenuButtonComponent {
  @Input() actions: MenuItem[] = [];
}
